import {
    FETCH_TOTAL_FEEDBACK_PROVIDERS_START,
    FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS,
    FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL,

} from "../../../constants";
import {
    FETCH_TOTAL_FEEDBACK_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getTotalFeedbackProviders = createVisualizationFetchAction(FETCH_TOTAL_FEEDBACK_URL, {
    START: FETCH_TOTAL_FEEDBACK_PROVIDERS_START,
    SUCCESS: FETCH_TOTAL_FEEDBACK_PROVIDERS_SUCCESS,
    FAIL: FETCH_TOTAL_FEEDBACK_PROVIDERS_FAIL,
});

